<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure><i class="icon icon-icon_qr-code"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                workspace <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                      <notice-published v-model="resource" label-published="Ce produit est actif." label-unpublished="Ce produit est inactif." :dates="true"></notice-published>

                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>
<!--                                <form-publication-state label="Etat" v-model="resource.publication_state_id"></form-publication-state>-->
                                <form-text label="Name" v-model="resource.name" required="true"></form-text>
                                <form-textarea label="Description" v-model="resource.description" required="true"></form-textarea>
                                <form-text label="Url" v-model="resource.url" required="true"></form-text>

                                <hr>

                                <figure>
                                    <a :href="resource.qr_code" target="_blank"><img :src="resource.qr_code" height="180"/></a>
                                </figure>

                              </fieldset>

                            </tab>
                            <tab name="Paramètres UTM">

                              <fieldset>
                                <h3>Paramètres UTM</h3>
                                <p class="headline"></p>

                                <form-text label="Campaign source" v-model="resource.utm_source" required="true"></form-text>
                                <form-text label="Campaign medium" v-model="resource.utm_medium"></form-text>
                                <form-text label="Campaign name" v-model="resource.utm_campaign"></form-text>
                                <form-text label="Campaign term" v-model="resource.utm_term"></form-text>
                                <form-text label="Campaign term" v-model="resource.utm_content"></form-text>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                    <footer>

                    </footer>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import ShortlinkService from './ShortlinkService.js';
    import Edit from '../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
            }
        },
        mounted: function(){
            this.initialize()
        },
        methods:{
            getResource: function(){
                return ShortlinkService
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shortlink/Edit.vue